import React from 'react';

import MessageBox from './MessageBox';

interface RequestPasswordResetSuccessProps {
  email: string;
  linkedAccount: boolean;
  parentFullName?: string;
}

const RequestPasswordResetSuccess = (props: RequestPasswordResetSuccessProps) => {
  const title = props.parentFullName ? 'Password Reset Request Sent' : 'Success!';
  return (
    <MessageBox
      header={title}
      message={
        props.linkedAccount
        ?
        `Your access password is managed by ${props.parentFullName.trim() || props.email}.
        We have sent them a message to ${props.email} to let them know that you need your password reset. `
        :
        `We've just sent an email to ${props.email} with a link to reset your password.
        Keep an eye on your spam folder.`
      }
    />
  )
}

export default RequestPasswordResetSuccess;
